// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
// import { getAnalytics } from "firebase/analytics"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCI44n2EYPoFkrvGahIbn-TLPm8NWsrNSY",
  authDomain: "my-ad-tool.firebaseapp.com",
  projectId: "my-ad-tool",
  storageBucket: "my-ad-tool.firebasestorage.app",
  messagingSenderId: "972466932288",
  appId: "1:972466932288:web:248a6d1870743c9ed16da5",
  measurementId: "G-B5TB0V2SVD",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
// const analytics = getAnalytics(app)
const auth = getAuth(app)
const db = getFirestore(app)

// Collection names
export const COLLECTIONS = {
  USERS: "users",
  STUDIOS: "studios",
  STUDIO_MEMBERSHIPS: "studioMemberships",
  STUDIO_INVITES: "studioInvites",
  DESIGNS: "designs",
  NOTIFICATIONS: "notifications",
}

// Invite statuses
export const INVITE_STATUS = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  EXPIRED: "expired",
  REVOKED: "revoked",
}

// User types
export const USER_TYPES = {
  REGULAR: "regular",
  STUDIO_ADMIN: "studio_admin",
}

// Studio roles
export const STUDIO_ROLES = {
  OWNER: "owner",
  ADMIN: "admin",
  MEMBER: "member",
  VIEWER: "viewer",
}

export { auth, db }
